module.exports = __webpack_public_path__ + "img/08.98b6e1e6.png";